<template>
  <div>
    <div class="annual-payment-contianer p-2">
      <img
        src="~/assets/images/secure payment.png"
        alt="pedalsure icon"
        style="margin: 0 auto 50px; width: 100px; display: block"
      />
      <div class="columns is-mobile">
        <div class="column ps-title" data-test="annual-payment-title">
          Annual Payment
        </div>
        <div class="column powered-by">
          Powered by
          <span class="icon fa-2x">
            <font-awesome-icon :icon="['fab', 'stripe']" />
          </span>
        </div>
      </div>

      <div>
        <form id="payment-form" @submit="checkForm">
          <div class="form-row">
            <div v-if="!isStripeLoaded" class="ps-loader">
              <Loader />
            </div>
            <!-- <label for="card-element"> Credit or debit card </label> -->
            <div id="card-element">
              <!-- A Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display form errors. -->
            <div id="card-errors" role="alert">
              {{ error }}
            </div>
          </div>
          <button
            :disabled="!isStripeLoaded"
            :class="{ 'is-loading': isLoading }"
            class="button ps-button is-fullwidth"
          >
            Pay
            <span v-if="$store.getters['quote/price'].total" class="pl-2">
              {{ $store.getters['quote/price'].total | toCurrency }}
              <span v-if="$store.getters['quote/addedHiplokTotal']">
                + £{{ $store.getters['quote/addedHiplokTotalPrice'] }}
                (
                <span v-if="$store.getters['quote/addedHiplok'].dx.count">
                  Hiplok DX:
                  {{ $store.getters['quote/addedHiplok'].dx.count }}
                </span>
                <span v-if="$store.getters['quote/addedHiplok'].gold.count">
                  Hiplok Gold:
                  {{ $store.getters['quote/addedHiplok'].gold.count }}
                </span>
                <span v-if="$store.getters['quote/addedHiplok'].edx.count">
                  Hiplok E-DX:
                  {{ $store.getters['quote/addedHiplok'].edx.count }}
                </span>
                )
              </span>
            </span>
          </button>
          <div class="mt-6 is-flex is-justify-content-space-between">
            <SecuritySeal />
            <div class="is-flex is-justify-content-flex-end">
              <div>
                <img
                  src="~/assets/images/payment/visa.png"
                  alt="payment icon"
                  style="width: 60px; display: block"
                />
              </div>
              <div>
                <img
                  src="~/assets/images/payment/mastercard.svg"
                  alt="payment icon"
                  style="width: 60px; display: block"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/common/Loader'
import SecuritySeal from '@/components/SecuritySeal'
/* eslint-disable no-console */
export default {
  name: 'MonthlyForm',
  components: { Loader, SecuritySeal },
  props: {
    isRenew: {
      type: Boolean,
      default: false,
    },
    renewPolicyCode: {
      type: String,
      default: '',
    },
    mtaRetry: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      isStripeLoaded: false,
      readyInterval: null,
      isLoading: false,
      error: null,
      reqData: null,
      card: null,
      stripeKey: null,
    }
  },
  head() {
    return {
      script: [{ src: 'https://js.stripe.com/v3/' }],
    }
  },
  computed: {
    ...mapGetters({
      addedUserDetails: 'quote/addedUserDetails',
      quote: 'quote/quote',
    }),
    stripe() {
      return window.Stripe(`${this.stripeKey}`)
    },
  },
  mounted() {
    this.getStripeKey()
    this.readyInterval = setInterval(async () => {
      if (window && window.Stripe) {
        clearInterval(this.readyInterval)
        await this.initStripe()
        this.isStripeLoaded = true
      }
    }, 200)
  },
  methods: {
    async getStripeKey() {
      try {
        const { key } = await this.$axios.$get('/api/payment/v1/pay/stripe-pk')
        this.stripeKey = key
      } catch (e) {
        console.log('error', e)
      }
    },
    async checkForm(e) {
      e.preventDefault()
      this.isLoading = true
      console.log('this.reqData', this.reqData)

      try {
        const { setupIntent, error } = await this.stripe.confirmCardSetup(
          this.reqData.intent,
          {
            payment_method: {
              card: this.card,
              billing_details: {
                name: `${this.addedUserDetails.firstName} ${this.addedUserDetails.lastName}`,
              },
            },
          }
        )
        if (error) {
          this.error = error.message
          console.log(
            'error',
            `message: ${error.message}, type:${error.type}, param:${error.param}`
          )
          this.$sentry.captureException(
            new Error(
              `message: ${error.message}, type:${error.type}, param:${error.param}`
            )
          )
        }
        console.log('setupIntent', setupIntent)

        if (setupIntent && setupIntent.error) {
          console.log(setupIntent.error.message)
        } else if (setupIntent && setupIntent.status === 'succeeded') {
          this.$router.push({
            path: `/dashboard`,
            query: { type: 'paid' },
          })
          if (!this.isRenew) {
            // Google analytic sync
            this.$gtm.push({
              event: 'purchase_complete',
              payment_type: 'annually',
              transactionId: this.quote.id,
              transactionTotal: this.quote.price.total,
              'prices.total_discounted': this.quote.price.total,
              policy_total: this.quote.price.total,
              prices: {
                discount_percent: this.quote.discount,
                total_discounted: this.quote.price.total,
              },
            })
            // Slack notification
            this.$axios.$post('/api/notifications/v1/policy-purchased', {
              userName: `${this.addedUserDetails.firstName} ${this.addedUserDetails.lastName}`,
              url: process.env.baseDomainUrl,
              policyType: this.isRenew ? 'Renew defer' : 'New business',
              paymentMethod: 'Stripe',
              code: this.quote.id,
              price: this.quote.price.total,
            })
          }
        }
        this.isLoading = false
      } catch (e) {
        console.log('eeee', e)
      }
    },
    async initStripe() {
      try {
        if (this.isRenew) {
          this.reqData = await this.$axios.$post(
            `/api/policy/v1/policy/${this.renewPolicyCode}/renew/annually`
          )
        } else if (this.mtaRetry) {
          console.log('mta pid', this.$store.getters['mtaQuote/mtaQuote'].pid)
          // this.reqData = await this.$axios.$post(
          //   // /api/policy/mta/turn/stripe_card/intent/${pid}
          //   `/api/policy/mta/turn/stripe_card/intent/${this.$store.getters['mtaQuote/mtaQuote'].pid}`
          // )
          this.reqData = await this.$axios.$post(
            '/api/policy/v1/policy/mta/pay-retry',
            {
              pid: this.$store.getters['mtaQuote/mtaQuote'].pid,
            }
          )
        } else {
          this.reqData = await this.$axios.$post(
            `/api/policy/v1/pay/${this.$route.params.quoteid}/annually`
          )
        }

        console.log('this.data', this.data)
        const elements = this.stripe.elements()
        const style = {
          base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
          },
        }
        this.card = elements.create('card', { style })
        this.card.mount('#card-element')

        this.card.on('change', ({ error }) => {
          console.log('error', error)
          this.isLoading = false
          if (error) {
            this.error = error.message
          } else {
            this.error = null
          }
        })

        // Handle form submission.
        // const form = document.getElementById('payment-form')
        // form.addEventListener('submit', async (event) => {
        //   event.preventDefault()

        // })
      } catch (error) {
        console.log('PAYMENT error', error)
        if (error.response) {
          console.log(error.response.data.error)
          this.error = error.response.data.error.error
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ps-title {
  font-size: 1rem;
  @include tablet {
    font-size: 1.5rem;
  }
}
.powered-by {
  font-size: 0.6rem;
  text-align: right;
  color: #939598;
}
.ps-loader {
  margin: 0 auto;
  display: block;
  top: 100px;
  width: 100px;
}
select {
  border-radius: 15px;
  height: 45px;
  width: 100%;
  border-color: #939598;
}
.annual-payment-contianer {
  max-width: 500px;
  width: 100%;
  margin: 20px auto;
}
.form-row {
  padding: 10px 0 20px;
  height: 100px;
}
</style>

<style lang="scss">
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 $ps-primary;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
